module.exports = __webpack_public_path__ + "static/media/OneucDesktopLogo.e67a1a12.svg";